export default (initialState = {}) => {
  return () => {
    return {
      file: null,
      is_tax_included: true,
      ...initialState,
    };
  };
};
